<template>
  <div class="vx-col w-5/6 ml-auto mr-auto">
    <span>
      <b v-if="id!=null">Edit {{title}}</b>
      <b v-else>Create {{title}}</b>
    </span>
    <div class="vx-row mb-6">
      <div class="vx-col w-full">
        <vs-input
          class="w-full"
          label="*Max Period (in month)"
          v-validate="'required'"
          name="Period"
          v-model="data.max_period"
        />
        <span class="text-danger text-sm" v-show="errors.has('Period')">{{
          errors.first("Period")
        }}</span>
      </div>
    </div>
    <div class="vx-row">
      <div class="vx-col w-full">
        <vs-button class="mr-3 mb-2" @click="handleSubmit">Submit</vs-button>
        <vs-button class="ml-4 mt-2" type="border" color="danger" v-on:click="handleClose">Close</vs-button>
      </div>
    </div>
  </div>
</template>
<script>

import Datepicker from "vuejs-datepicker";
export default {
  components: {
    Datepicker
  },
  props: {
    id: {
      type: Number
    },
    url: {
      type: String
    },
    title: {
      type: String
    }
  },

  data() {
    return this.initialState();
  },
  methods: {
    initialState() {
      return {
        data: {
          id: null,
          max_period: 0,
        }
      };
    },
    handleSubmit() {
      this.$validator.validateAll().then(result => {
        if (result && this.validateParam()) {
          this.$vs.loading();
          if (this.id) {
            this.putData();
          } else {
            this.postData();
          }
        }
      });
    },
    validateParam(){
      if( this.data.max_period == "" ){
        this.$vs.notify({
          color: "warning",
          title: "Warning",
          text: "Max period is required!",
          position: "top-right",
          iconPack: "feather",
          icon: "icon-alert-circle"
        });
        return false;
      } else if ( parseInt(this.data.max_period) <= 0 || isNaN( parseInt( this.data.max_period ) ) ){
        this.$vs.notify({
          color: "warning",
          title: "Warning",
          text: "Invalid max period!",
          position: "top-right",
          iconPack: "feather",
          icon: "icon-alert-circle"
        });
        this.$vs.loading.close();
      } else {
        return true;
      }
    },
    paramData() {
      return {        
        max_period: parseInt(this.data.max_period)
      };
    },
    postData() {
      this.$http
        .post(this.url, this.paramData())
        .then(resp => {
          this.$vs.loading.close();
          console.log(resp);
          if (resp.code == 200) {
            this.handleClose();
            this.$vs.notify({
              color: "success",
              title: "Success",
              text: "New " + this.title + " Created",
              position: "top-right",
              iconPack: "feather",
              icon: "icon-x-circle"
            });
          } else {
            this.$vs.notify({
              color: "danger",
              title: "Error",
              text: resp.message,
              position: "top-right",
              iconPack: "feather",
              icon: "icon-x-circle"
            });
          }
        })
        .catch(error => {
          this.$vs.loading.close();
          console.log(error);
        });
    },
    putData() {
      this.$http
        .put(this.url + "/" + this.id, this.paramData())
        .then(resp => {
          this.$vs.loading.close();
          console.log(resp);
          if (resp.code == 200) {
            this.handleClose();
            this.$vs.notify({
              color: "success",
              title: "Success",
              text: this.title + " Updated",
              position: "top-right",
              iconPack: "feather",
              icon: "icon-x-circle"
            });
          } else {
            this.$vs.notify({
              color: "danger",
              title: "Error",
              text: resp.message,
              position: "top-right",
              iconPack: "feather",
              icon: "icon-x-circle"
            });
          }
        })
        .catch(error => {
          this.$vs.loading.close();
          console.log(error);
        });
    },
    handleClose() {
      window.scrollTo(0, 0);
      this.$emit("close");
    },
    getData() {
      this.$vs.loading();
      this.$http
        .get(this.url + "/" + this.id)
        .then(resp => {
          this.$vs.loading.close();
          console.log(resp);
          if (resp.code == 200) {
            this.data.id = resp.data.id;
            this.data.max_period = resp.data.max_period;
            // this.data.max_period = 0;
          } else {
            this.$vs.notify({
              color: "danger",
              title: "Error",
              text: resp.message,
              position: "top-right",
              iconPack: "feather",
              icon: "icon-x-circle"
            });
          }
        })
        .catch(error => {
          this.$vs.loading.close();
          console.log(error);
        });
    },
    // setPaymentMethodId(val) {
    //   console.log(val, 'set')
    //   this.data.paymentMethodId = val;
    // }
  },
  mounted() {
    if (this.id) {
      this.getData();
    }
  },
  computed: {},
  watch: {
    id(v) {
      if (v) {
        this.getData();
      } else {
        Object.assign(this.$data, this.initialState());
      }
    }
  }
};
</script>
<style >
</style>
